export const projectData = {

  title: "Projects",
  subtitle: "",
  description: `💻 A collection of hands-on projects spanning cloud-native development, full-stack engineering, and generative AI. Technologies used across projects include AWS, GCP, Docker, Kubernetes, React, Flutter, LangChain, and more.`,

  platforms: {
    "GITHUB": {
      name: 'Github',
      iconifyClass: "simple-icons:github",
      style: {
        color: "#808080"
      }
    },

    "WEB": {
      name: 'Web',
      iconifyClass: "streamline:web-solid",
      style: {
        color: "#CCCCF"
      }
    },

    "APPSTORE": {
      name: 'AppStore',
      iconifyClass: "ion:logo-apple-appstore",
      style: {
        color: "#0096FF"
      }
    },

    "PLAYSTORE": {
      name: "PlayStore",
      iconifyClass: "ion:logo-google-playstore",
      style: {
        color: "#ffffff"

      }
    }



  },


  projectTypes: [
    {
      name: "Cloud Infra",
      type: "CLOUD_INFRA"

    },
    {
      name: "Full stack",
      type: "FULL_STACK"
    },
    {
      name: 'AI',
      type: "AI"
    },

  ],

  techStacks: {
    'FLUTTER': {
      name: "Flutter",
      iconifyClass: "simple-icons:flutter",
      style: {
        color: "#02569B",
      },
    },

    "DART": {
      name: "Dart",
      iconifyClass: "simple-icons:dart",
      style: {
        color: "#29B0EE",
      },
    },

    'FIREBASE': {
      name: "Firebase",
      iconifyClass: "logos-firebase",

    },

    "GCP": {
      name: "Google Cloud Platforms",
      iconifyClass: "logos:google-cloud",

    },

    "UNITY": {
      name: "Unity",
      iconifyClass: "fontisto:unity",
      style: {
        color: "#FFFFFF",
      },
    },

    "HTML5": {
      name: "HTML5",
      iconifyClass: "simple-icons:html5",
      style: {
        color: "#E34F26",
      },
    },

    "CSS3": {
      name: "CSS3",
      iconifyClass: "fa-css3",
      style: {
        color: "#1572B6",
      },
    },

    "JAVASCRIPT": {
      name: "JavaScript",
      iconifyClass: "simple-icons:javascript",
      style: {
        color: "#F7DF1E",
      },
    },

    "REACTJS": {
      name: "ReactJS",
      iconifyClass: "simple-icons:react",
      style: {
        color: "#61DAFB",
      },
    },

    "NODEJS": {
      name: "NodeJS",
      iconifyClass: "simple-icons:node-dot-js",
      style: {
        color: "#339933",
      },
    },

    "NPM": {
      name: "NPM",
      iconifyClass: "simple-icons:npm",
      style: {
        color: "#CB3837",
      },
    },

    "AWS": {
      name: "AWS",
      iconifyClass: "skill-icons:aws-dark",

    },

    "DOCKER": {
      name: "DOCKER",
      iconifyClass: "simple-icons:docker",

    },

    "KUBERNETES": {
      name: "KUBERNETES",
      iconifyClass: "skill-icons:kubernetes",

    },


    "GITHUBACTIONS": {
      name: "GITHUBACIONS",
      iconifyClass: "simple-icons:githubactions",

    },

    "POSTGRESQL": {
      name: "POSTGRESQL",
      iconifyClass: "simple-icons:postgresql",

    },

    "MYSQL": {
      name: "MYSQL",
      iconifyClass: "skill-icons:mysql-dark"
    },

    "PHP": {
      name: "PHP",
      iconifyClass: "simple-icons:php",

    },

    "SUPABASE": {
      name: "Supabase",
      iconifyClass: "simple-icons:supabase",
    },

    "PYTHON": {
      name: "Python",
      iconifyClass: "devicon:python",

    },

    "LANGCHAIN": {
      name: "LangChain",
      iconifyClass: "simple-icons:langchain",

    },
    "FLASK": {
      name: "Flask",
      iconifyClass: "skill-icons:flask-light",

    },
    "OPENAI": {
      name: "OpenAI",
      iconifyClass: "simple-icons:openai",

    },
    "PINECONE": {
      name: "Pinecone",
      iconifyClass: "logos:pinecone-icon",

    },








  },

}


